(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ldas-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ldas-bundle-builder')) {
    customElements.define('ldas-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.selected = [];
        const requestedQuantity = Number(new URL(location.href).searchParams.get('quantity'));
        this.target = [2,3,4].includes(requestedQuantity) ? requestedQuantity : 2;
        this.querySelector('input[type=radio][value="' + this.target + '"]').checked = true;
        this.busy = false;
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:'USD'});
        this.addEventListener('change', event => {
          if (event.target.matches('input[type=radio]')) this.target = Number(event.target.value);
          this.render();
        });
        this.querySelector('[data-search]').addEventListener('input', event => {
          const term = event.target.value.trim().toLocaleLowerCase();
          this.querySelectorAll('.ldas-card').forEach(card => card.hidden = !card.dataset.title.toLocaleLowerCase().includes(term));
        });
        this.addEventListener('click', event => {
          const add = event.target.closest('[data-add]');
          if (add && !add.disabled) {
            const card = add.closest('.ldas-card');
            const variant = card.querySelector('[data-variant]');
            this.selected.push({id:variant.value, title:card.dataset.title, variant:variant.selectedOptions[0].textContent});
            this.render();
          }
          const remove = event.target.closest('[data-remove]');
          if (remove) {this.selected.splice(Number(remove.dataset.remove),1); this.render();}
          if (event.target.closest('[data-submit]')) this.submit();
        });
        this.render();
      }
      render() {
        const list = this.querySelector('[data-selected]');
        list.replaceChildren();
        this.selected.forEach((item,index) => {
          const li = document.createElement('li');
          li.append(document.createTextNode(item.title + ' — ' + item.variant));
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.remove = index; button.textContent = this.labels.remove;
          button.setAttribute('aria-label', this.labels.remove + ' ' + item.title + ' ' + item.variant);
          button.disabled = this.busy; li.append(button); list.append(li);
        });
        this.querySelector('[data-progress]').textContent = this.labels.progress.replace('[count]',this.selected.length).replace('[target]',this.target);
        this.querySelectorAll('[data-add]').forEach(button => button.disabled = this.busy || this.selected.length >= this.target || !button.closest('.ldas-card').querySelector('[data-variant]').value);
        this.querySelector('[data-submit]').disabled = this.busy || this.selected.length !== this.target;
        this.querySelectorAll('input[type=radio], [data-variant]').forEach(input => input.disabled = this.busy);
      }
      async submit() {
        if (this.busy || this.selected.length !== this.target) return;
        this.busy = true; this.render();
        const result = this.querySelector('[data-result]');
        result.textContent = this.labels.adding;
        const root = this.dataset.root;
        try {
          const beforeResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
          if (!beforeResponse.ok) throw new Error(this.labels.error);
          const before = await beforeResponse.json();
          const quantities = new Map();
          this.selected.forEach(item => quantities.set(item.id,(quantities.get(item.id)||0)+1));
          const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:Array.from(quantities,([id,quantity])=>({id,quantity}))})});
          const added = await response.json();
          if (!response.ok) throw new Error(added.description || this.labels.error);
          const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
          if (!cartResponse.ok) throw new Error(this.labels.error);
          const cart = await cartResponse.json();
          const expected = {2:12900,3:17900,4:22900}[this.target];
          result.textContent = (before.item_count === 0 && cart.total_price !== expected ? this.labels.mismatch : this.labels.added).replace('[total]',this.money.format(cart.total_price/100));
          this.selected = [];
        } catch (error) {result.textContent = error.message || this.labels.error;}
        finally {this.busy = false; this.render();}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
